import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PreferenceStateService {
  constructor() {}

  private preferenceOptionsSubject = new BehaviorSubject<string[]>([]);
  preferenceOptions = this.preferenceOptionsSubject.asObservable();

  private selectedOptionSubject = new BehaviorSubject<string | null>(null);
  selectedOption = this.selectedOptionSubject.asObservable();
  updateOptions(prefs: any[]) {
    const options = prefs
      .filter(
        (p) =>
          (p.name === "COMPANY_MONETARY_INCENTIVES" ||
            p.name === "COMPANY_BADGING") &&
          p.enabled
      )
      .map((p) => p.name);

    this.preferenceOptionsSubject.next(options);
  }
  setSelectedOption(option: string) {
    this.selectedOptionSubject.next(option);
  }

  getSelectedOption(): string | null {
    return this.selectedOptionSubject.value;
  }
}
